export default __webpack_public_path__ + "static/media/power-off.d63d4a77.svg";